var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51666 2V0.5H4.52777V2V2.5H5.02777H13.0722H13.5722V2V0.5H14.5833V2V2.5H15.0833H16.0889C16.9214 2.5 17.6 3.17875 17.6 4V18C17.6 18.8213 16.9214 19.5 16.0889 19.5H2.01111C1.17016 19.5 0.500097 18.823 0.5 18.0002C0.5 18.0001 0.5 18.0001 0.5 18L0.510056 4.00036V4C0.510056 3.17385 1.17337 2.5 2.01111 2.5H3.01666H3.51666V2ZM16.0889 18.5H16.5889V18V7V6.5H16.0889H2.01111H1.51111V7V18V18.5H2.01111H16.0889ZM9.54999 15.5V11.5H13.5778V15.5H9.54999Z",
    fill: "#0066FF",
    stroke: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.606305e97d97ee430e9e6d2df5962485.svg";
export { ForwardRef as ReactComponent };